export const Colors = Object.freeze({
	black: '#000000',
	blue: '#0000FF',
	brown: '#A52A2A',
	fuchsia: '#FF00FF',
	green: '#00FF00',
	red: '#FF0000',
	yellow: '#FFFF00',
});
